import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import "./flightbooking.css"; // optional CSS
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";

const FlightBooking = ({ isOpen, setIsOpen }) => {
  const form = useRef();

  // Flight & contact state
  const [tripType, setTripType] = useState("one-way");
  const [fromAirport, setFromAirport] = useState("");
  const [toAirport, setToAirport] = useState("");
  const [departureDate, setDepartureDate] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [passengers, setPassengers] = useState("1 Adult");
  const [cabinClass, setCabinClass] = useState("Economy");
  const [buyMiles, setBuyMiles] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
    const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Airports list
  const airports = [
    { code: "KHI", name: "Karachi (Jinnah International)" },
    { code: "LHE", name: "Lahore (Allama Iqbal International)" },
    { code: "ISB", name: "Islamabad (International)" },
    { code: "DXB", name: "Dubai (International)" },
    { code: "JFK", name: "New York (John F. Kennedy)" },
    { code: "LAX", name: "Los Angeles (International)" },
    { code: "SYD", name: "Sydney (Kingsford Smith)" },
  ];

  // Phone input handler
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value);
  };

  const handleSwapRoute = () => {
    setFromAirport((prevFrom) => {
      const nextFrom = toAirport;
      setToAirport(prevFrom);
      return nextFrom;
    });
  };

  // Form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    // if (!name || !email || !fromAirport || !toAirport || !departureDate) {
    //   toast.error("Please fill all required fields.");
    //   return;
    // }

    // emailjs
    //   .sendForm(
    //     "service_ejoxvkh", // Your EmailJS Service ID
    //     "template_8oy6tjn", // Your Template ID
    //     form.current,
    //     "aExFZAhEcj6WfvGDr" // Your Public Key
    //   )
    //   .then(
    //     () => {
    //       toast.success("Message sent successfully!");
    //       form.current.reset();
    //       setTripType("one-way");
    //       setFromAirport("");
    //       setToAirport("");
    //       setDepartureDate("");
    //       setReturnDate("");
    //       setPassengers("1 Adult");
    //       setCabinClass("Economy");
    //       setBuyMiles(false);
    //       setName("");
    //       setEmail("");
    //       setPhone("");
    //       setMessage("");
    //       setIsOpen(false);
    //     },
    //     (error) => {
    //       console.error("FAILED...", error.text);
    //       toast.error("Failed to send message, please try again.");
    //     }
    //   );

    toast.success("Message received! We’ll contact you shortly.");
    form.current?.reset?.();
    setTripType("one-way");
    setFromAirport("");
    setToAirport("");
    setDepartureDate("");
    setReturnDate("");
    setPassengers("1 Adult");
    setCabinClass("Economy");
    setBuyMiles(false);
    setName("");
    setEmail("");
    setPhone("");
    setMessage("");
    setIsOpen(false);
  };

  if (!isOpen) return null;







  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-title">
            <div className="modal-title-icon" aria-hidden="true">
              <i className="fa fa-plane" />
            </div>
            <div className="modal-title-text">
              <h2>Book a Flight</h2>
              <p>Send us your details and we’ll get back quickly.</p>
            </div>
          </div>

          <button
            type="button"
            className="close-x"
            aria-label="Close"
            onClick={() => setIsOpen(false)}
          >
            &times;
          </button>
        </div>

        <form ref={form} onSubmit={handleSubmit} className="flight-form">
          <div className="form-section">
            <div className="section-title">
              <i className="fa fa-suitcase" aria-hidden="true" />
              <span>Trip details</span>
            </div>

            {/* Trip Type */}
            <div className="trip-types">
              <label className={tripType === "one-way" ? "trip-pill is-active" : "trip-pill"}>
                <input
                  type="radio"
                  name="tripType"
                  value="one-way"
                  checked={tripType === "one-way"}
                  onChange={(e) => setTripType(e.target.value)}
                />
                One-way
              </label>
              <label className={tripType === "roundtrip" ? "trip-pill is-active" : "trip-pill"}>
                <input
                  type="radio"
                  name="tripType"
                  value="roundtrip"
                  checked={tripType === "roundtrip"}
                  onChange={(e) => setTripType(e.target.value)}
                />
                Roundtrip
              </label>
            </div>

            {/* Route */}
            <div className="route-row">
              <div className="input-group">
                <label>From</label>
                <select
                  className="form-input"
                  name="fromAirport"
                  value={fromAirport}
                  onChange={(e) => setFromAirport(e.target.value)}
                >
                  <option value="">Select departure city</option>
                  {airports.map((airport) => (
                    <option key={airport.code} value={airport.name}>
                      {airport.code} - {airport.name}
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="button"
                className="swap-btn"
                onClick={handleSwapRoute}
                aria-label="Swap route"
                title="Swap route"
              >
                <i className="fa fa-exchange" aria-hidden="true" />
              </button>

              <div className="input-group">
                <label>To</label>
                <select
                  className="form-input"
                  name="toAirport"
                  value={toAirport}
                  onChange={(e) => setToAirport(e.target.value)}
                >
                  <option value="">Select arrival city</option>
                  {airports.map((airport) => (
                    <option key={airport.code} value={airport.name}>
                      {airport.code} - {airport.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Miles Option */}
            <label className="check-row">
              <input
                type="checkbox"
                name="buyMiles"
                value={buyMiles ? "Yes" : "No"}
                checked={buyMiles}
                onChange={(e) => setBuyMiles(e.target.checked)}
              />
              <span>Buy ticket with miles</span>
            </label>

            {/* Dates */}
            <div className="form-row">
              <div className="input-group">
                <label>Departure date</label>
                <input
                  className="form-input"
                  type="date"
                  name="departureDate"
                  value={departureDate}
                  onChange={(e) => setDepartureDate(e.target.value)}
                />
              </div>

              {tripType === "roundtrip" && (
                <div className="input-group">
                  <label>Return date</label>
                  <input
                    className="form-input"
                    type="date"
                    name="returnDate"
                    value={returnDate || ""}
                    onChange={(e) => setReturnDate(e.target.value)}
                  />
                </div>
              )}
            </div>

            {/* Passengers & Class */}
            <div className="form-row">
              <div className="input-group">
                <label>Passengers</label>
                <select
                  className="form-input"
                  name="passengers"
                  value={passengers}
                  onChange={(e) => setPassengers(e.target.value)}
                >
                  <option>1 Adult</option>
                  <option>2 Adults</option>
                  <option>3 Adults</option>
                </select>
              </div>

              <div className="input-group">
                <label>Class</label>
                <select
                  className="form-input"
                  name="cabinClass"
                  value={cabinClass}
                  onChange={(e) => setCabinClass(e.target.value)}
                >
                  <option>Economy</option>
                  <option>Business Class</option>
                  <option>First Class</option>
                </select>
              </div>
            </div>
          </div>

          <div className="form-section">
            <div className="section-title">
              <i className="fa fa-envelope" aria-hidden="true" />
              <span>Contact</span>
            </div>

            {/* Contact Info */}
            <div className="form-row">
              <div className="input-group">
                <label>Name</label>
                <input
                  className="form-input"
                  type="text"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Full name"
                  autoComplete="name"
                />
              </div>

              <div className="input-group">
                <label>Email</label>
                <input
                  className="form-input"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="input-group">
                <label>Phone</label>
                <input
                  className="form-input"
                  type="text"
                  name="phone"
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="Phone number"
                  maxLength="15"
                  inputMode="numeric"
                  autoComplete="tel"
                />
              </div>
            </div>

            {/* Optional Message */}
            <div className="form-row">
              <div className="input-group">
                <label>Message (optional)</label>
                <textarea
                  className="form-input"
                  name="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Anything we should know?"
                  rows="4"
                />
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={() => setIsOpen(false)}>
              Cancel
            </button>
            <button type="submit" className="search-btn">
              <i className="fa fa-paper-plane" aria-hidden="true" /> Send message
            </button>
          </div>

        </form>

        <ToastContainer />
      </div>
    </div>
  );
};

export default FlightBooking;
